/** Detect phone/tablet user agents (not desktop browser width). */
export function isMobileDevice() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return (
    /android/i.test(userAgent) ||
    (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream)
  );
}

/** Default landing after open / login: mobile home vs desktop home. */
export function getDefaultHomePath() {
  return isMobileDevice() ? '/mhome' : '/home';
}
